import { Bike } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Panel } from '..';
import { useProjectStore, usePropStore } from '../../../context';
import { Prop, PropType, Role, TScriptId } from '@talon/web/lib/api';

export interface IProjectPropPanelProps {
  scriptId?: TScriptId;
  role: Role;
}

export const ProjectPropPanel = observer(({ scriptId, role }: IProjectPropPanelProps) => {
  const [props, setProps] = useState<Prop[]>([]);
  const propStore = usePropStore();
  const projectStore = useProjectStore();
  useEffect(() => {
    if (!role) return;
    const getProps = async () => {
      const props = await propStore.getPropsByRoleId(role.id);
      props && setProps(props);
    };
    getProps();
  }, [role]);

  const newProp = async () => {
    if (!projectStore.currentProject?.id) return;
    const propRequest = {
      name: 'New Prop',
      type: PropType.Automobile,
      scriptIds: scriptId ? [scriptId] : [],
      ownerId: role.id,
      projectId: projectStore.currentProject.id,
    };
    const prop = await propStore.createProp(propRequest);
    props && prop && setProps([...props, prop]);
    prop && role.props?.push(prop);
  };

  const deleteProps = async (ids: string[]) => {
    ids.forEach(async (id) => await propStore.deleteProp(id));
    setProps(props.filter((r) => !ids.includes(r.id)));
    role.props = role.props?.filter((r) => !ids.includes(r.id));
  };

  const updateProp = async (update: Prop, index: number) => {
    const prop = await propStore.updateProp(update);
    if (!prop) return;
    const newProps = [...props];
    newProps[index] = prop;
    setProps(newProps);
    role.props = role.props?.map((r) => (r.id === prop.id ? prop : r));
  };

  return (
    <Panel
      items={props}
      newItem={newProp}
      deleteItems={deleteProps}
      updateItem={updateProp}
      label="Prop"
      labelPlural="Props"
      addIcon={<Bike />}
      types={[
        {
          label: 'Prop Type',
          key: 'type',
          values: Object.values(PropType),
        },
      ]}
    />
  );
});
